<template>
 
     <div class="compact-box">
        <h3>{{$route.query.r == 'he' ? '借款合同' : '借款申请书'}}</h3>
        <div class="img">

        </div>
        <div class="icon">
            <div class="el-icon-download"></div>
            <div class="el-icon-arrow-left" @click="back()"></div>
        </div>
     </div>
  
</template>

<script>
export default {
    created(){
        console.log(this.$route.query.Obj)
        console.log(JSON.parse(this.$route.query.Obj))
    },
    methods: {
        back(){
           this.$router.push({
            path:"/loan-tcustbase"
           })
        }
    },
}
</script>

<style lang="scss" scoped>
.compact-box{
    margin: 50px auto;
    width: 600px;
    text-align: center;
    position: relative;
}
  .img{
    height: 800px;
    width: 600px;
    background: skyblue;
  }
  .icon{
    position: absolute;
    height: 80px;
    width: 40px;
    left: 600px;
    top: 60%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    >div{
        width: 30px;
        height: 30px;
        background: orange;
        border-radius: 50%;
        text-align: center;
        line-height: 30px;
        font-size:16px ;
        font-weight: 900;
    }
  }

</style>